var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPriorityMedium = function SvgPriorityMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 6,
    fill: "none",
    viewBox: "0 0 16 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED8936",
    d: "M1 0a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2zM1 4a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2z"
  })));
};
export default SvgPriorityMedium;